import { getAcreditContentData } from '@root/constants/formData';
import { A_CREDIT_MERCHANT } from '@root/constants/paths';
import { lazy } from 'react';
import { getACreditPayRoutes } from './acreditPayRoutes';
import { getACreditVerifyRoutes } from './acreditVerifyRoutes';

const Layout = lazy(() => import('@pages/acredit/Layout'));

const { header } = getAcreditContentData();

export const aCreditRoutes = {
  path: A_CREDIT_MERCHANT,
  element: <Layout headerContent={header} />,
  children: [...getACreditVerifyRoutes(), ...getACreditPayRoutes()]
};
